"use client";

import { useEffect, useState, useContext, useRef } from "react";
import { GAEvent, GA_EVENTS } from "@/helpers/gaEvents";
import styles from "./SideButtons.module.scss";
import cn from "clsx";
import { pushToDataLayer } from "@/helpers/gtag";
import { IModalActions, ModalTypes } from "@/types/modal";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import { ModalContext } from "@/context/ModalContext";
import VideoCounselling from "@/components/organisms/HeaderOpt/VideoCounselling";
import CloseScholarship from "@/SvgIcons/CloseScholarship";
import { usePathname } from "next/navigation";
import { StorageService } from "@/helpers/storage.service";
import updateImageDomain from "@/common/imageUrlReplace";

const SCHOLORSHIPS_PATHS = ['/']

const SideButtons = ({ data, modalType, pageType, associatedPrograms, isTestScholarshipEnabled = false }) => {
  const { modalDispatch } = useContext(ModalContext);
  const { STICKY_CTA_TEL, STICKY_CTA_WHATSAPP, CALL_CHAT_INTERACTION } = GAEvent;
  const [isToolTipVisible,setIsToolTipVisible] = useState(false);

  const pathName = usePathname();

  const isBlogDetailsPage = pathName.includes('/blog/')
  const filterTestScholorship = SCHOLORSHIPS_PATHS.includes(pathName) || isBlogDetailsPage || isTestScholarshipEnabled;

  const [isVisible, setIsVisible] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isMobileViewDisabled, setIsMobileViewDisabled] = useState(true);
  const res = data?.filter((x, i) => x?.enabled && i !== 0);
  const timeoutRef = useRef(null);  

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.location.pathname === "/" || window.location.pathname === "/mba-campus-immersion-online" || pageType === "programDetails" || pageType === "specialization" || window.location.pathname === "/scholarship") {
        if (window.scrollY > 0.7 * window.innerHeight) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      } else {
        setIsVisible(false);
      }
      const tooltipSeen = sessionStorage.getItem('tooltipTestScholarship');

      if (tooltipSeen !== 'true') {
        const hasScrolledEnough = window.scrollY > 0;
      
        if (filterTestScholorship && hasScrolledEnough) {
          setIsToolTipVisible(true);
        }
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    if(window.innerWidth < 1201){ 
      setIsMobileView(true);
    } else{
      setIsMobileView(false);
    }
    setIsMobileViewDisabled(false);

    if (sessionStorage.getItem('tooltipTestScholarship') === 'true'){
      return;
    }else{
      if(filterTestScholorship){
       timeoutRef.current = setTimeout(() => {
          setIsToolTipVisible(true);
          window.removeEventListener("scroll", toggleVisibility);
        }, 3000);
      }
    }

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const handleClick = (item) => {
    
    const itemUrl = item?.url || "#";
    if (itemUrl.includes("tel")) {
      // for tel
      const gaData = GA_EVENTS.get(STICKY_CTA_TEL);
      pushToDataLayer(gaData);
      const gaData2 = {
        ...GA_EVENTS.get(CALL_CHAT_INTERACTION),
        cta_text: "call_us",
        section_name: "sticky_sidetray",
        page_type: getGlobalStateValue("pageType"),
      };
      pushToDataLayer(gaData2);

      window.webengage.track("Call Us Clicked",{
        "Section Name": "sticky_sidetray"
      })

    } else if (itemUrl.includes("whatsapp")) {
      // for whatsapp
      const gaData = GA_EVENTS.get(STICKY_CTA_WHATSAPP);
      pushToDataLayer(gaData);

      const gaData2 = {
        ...GA_EVENTS.get(CALL_CHAT_INTERACTION),
        cta_text: "whatsapp_chat",
        section_name: "sticky_sidetray",
        page_type: getGlobalStateValue("pageType"),
      };
      pushToDataLayer(gaData2);
    }
  };

  const renderItemUrl = (itemUrl) => {
    return itemUrl.includes("tel") && !isMobileView ? "#" : itemUrl;
  };

  const fireGTOpenCTA = ()  => {

    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType,
        modalData: { associatedPrograms }
      },
    });


   setTimeout(() => {

     pushToDataLayer({
       event: "lead_initiate",
       cta_text: "Apply Now",
       section_name: "side_widget",
       header_title: "header_title",
       page_type: getGlobalStateValue("pageType"),
       page_url: location.pathname,
     });

     updateStateSession({
       sectionTitle: "header_title",
       leadStartingCta: "Apply Now",
       parentSection: "side_widget",
     });
     
   }, 2000); 
  }
  


  const fireGtEvents = () => {

      modalDispatch({
        type: IModalActions.OpenModal,
        data: {
          modalType: ModalTypes.CallUsModal,
        },
      });

      pushToDataLayer({
        ...GA_EVENTS.get(CALL_CHAT_INTERACTION),
        cta_text: "call_us",
        section_name: "sticky_sidetray",
        page_type: getGlobalStateValue("pageType")
      })

      window.webengage.track("Call Us Clicked", {
        "Section Name": "sticky_sidetray"
      })
  }

  const handleRedirect = () =>{

    sessionStorage.setItem('tooltipTestScholarship', 'true');
    setIsToolTipVisible(false);
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType:ModalTypes.ConnectModalScholarship,
        modalData:{isTestScholarship:true}
      },
    });

    setTimeout(()=>{
    
          pushToDataLayer({
            event: "test_initiate",
            cta_text: "Start_Test",
            section_name: "Popup",
            page_type: getGlobalStateValue("pageType"),
            page_url: window.location.href,
          });
    
          updateStateSession({
            parentSection: "Popup",
            leadStartingCta: "Start Test",
          })

        },1500)
  }
  const tempisSessionModalActive = StorageService.get("timeConnectModal");


  const handleClose = () => {
    sessionStorage.setItem('tooltipTestScholarship', 'true');
    setIsToolTipVisible(false);
    const timer= setTimeout(() => {
      const modalElement = document.querySelector("div#_modal");
    clearTimeout(timeoutRef.current);
    if( !modalElement.childElementCount && !tempisSessionModalActive){
      if (
        window.location.pathname.includes("master-of-business-administration-online") ||
        window.location.pathname.includes("master-of-computer-applications-online") ||
        window.location.pathname.includes("bachelor-of-business-administration-online") ||
        window.location.pathname.includes("bachelor-of-computer-applications-online")
      ) {
          modalDispatch({
            type: IModalActions.UpdateModal,
            data: {
              modalType: ModalTypes.CallUsModal_V2, 
              isModalOpen: true,
            },
          });
          StorageService.set("timeConnectModal", true);
              clearTimeout(timer);
      }
      else  {
        modalDispatch({
          type: IModalActions.UpdateModal,
          data: {
            modalType: ModalTypes.CallingSticky_Modal, 
            isModalOpen: true,
          },
        });
        StorageService.set("timeConnectModal", true);
            clearTimeout(timer);
    }
    }
},30000)
  }




  return (
    <>
      <div className={styles.sideBtnRoot}>
      {isToolTipVisible && (
        <div className={cn(styles.tooltipDiv, isVisible || isBlogDetailsPage ? styles.tooltipAboveButton : styles.tooltipAtBottom)}>
          <div className={styles.tooltipClose} onClick={handleClose}><CloseScholarship/></div>
          <div className={styles.tooltipPara}>
            <div>
              <div className="flex justify-center relative right-5">
              <img height={70} width={70} src="https://static.amityonline.com/_s/Amity_University_Online_Logo_1_1_1_85205f7e8d.webp" alt="Amity Online Logo"></img>
              </div>
              <img className="w-[80%] m-auto" src="https://static.amityonline.com/_s/Frame_1000004491_1_f48fa98aa4.webp" alt="Instant Scholarship"></img>
            </div>
            <div className="mt-[0.5rem]">
            <span className="flex justify-center gap-[0.3rem]">Take Our Instant <span className={styles.toolParaDanger}> 15 Mins</span></span>
            <p> Scholarship Test Today!</p>
            </div>
          </div>
          <button className={styles.tooltipButton} onClick={handleRedirect}>START TEST</button>
        </div>
      )}
        <div className={`sideButtons flex flex-col items-center ${styles.buttonPosition} ${styles.btnWrapper}`}>
          {res?.map((item, i) => (
            <div className={styles.imgSize} key={i}>
              {item.title === "call-button" && !isMobileView ? (
                <button
                  onClick={fireGtEvents}
                  className={styles.stickCTAbtn}
                  disabled={isMobileViewDisabled}
                >
                  <img
                    id="call-icon"
                    className={cn("aspect-square", styles.imgIconSize)}
                    src={updateImageDomain(item?.source?.data?.[0]?.attributes?.url)}
                    alt={item?.alt || "call us"}
                    loading="lazy"
                    title="call us"
                    width={50}
                    height={50}
                  />
                </button>
              ) : (
                <>
                  <a
                    href={renderItemUrl(item?.url) || "#"}
                    onClick={(e) => {
                      if (isMobileViewDisabled) {
                        e.preventDefault();
                      }
                      handleClick(item)
                    }}
                    target={item?.target?.[0] || "_self"}
                  >
                    <img
                      id="wa-icon"
                      className={cn("aspect-square", styles.imgIconSize)}
                      src={updateImageDomain(item?.source?.data?.[0]?.attributes?.url)}
                      alt={item?.alt || "wa-icon"}
                      loading="lazy"
                      title="wa-icon"
                      width={50}
                      height={50}
                    />
                  </a>

                </>
              )}
            </div>
          ))}
          <VideoCounselling showTooltip={false}/>
          {isVisible && (
            <div className={styles.stickyApplymob}>
              <div onClick={fireGTOpenCTA} className={styles.stickyApplyBtn}>
                APPLY NOW
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default SideButtons;
